export default "__VITE_ASSET__DxopIEhI__"